import JSONModel from "sap/ui/model/json/JSONModel";
import Model from "sap/ui/model/Model";
import VariantManagementService from "vamos/cockpit/base/services/VariantManagementService";
import { Route$PatternMatchedEvent } from "sap/ui/core/routing/Route";
import BaseController from "vamos/cockpit/base/controller/type/BaseController";

/**
 * @namespace vamos.cockpit.base.controller
 * */
export default class BaseTypeController extends BaseController {


    protected variantsLoaded: Promise<Model>;
    protected routeName: string;

    onInit(): void {
        super.onInit();
        this.variantsLoaded = VariantManagementService.initVariants.call(this);
        this.routeName = this.getRouter().getRouteInfoByHash(this.getHash())?.name;
        if (!this.runInit && this.onRoutePatternMatched) {
            // @ts-ignore
            this.getRouter().getRoute(this.routeName).attachPatternMatched(this.onRoutePatternMatched, this, null);
        }

        void this.variantsLoaded.then((tablesModel: Model) => {
            if (this.afterVariantsLoaded) {
                this.afterVariantsLoaded(tablesModel as JSONModel);
            }
        });
    }

    protected afterVariantsLoaded(tablesModel: JSONModel): void {
    }

    onRoutePatternMatched(event: Route$PatternMatchedEvent) {
        this.handleTabHistoryFromListViews(event.getParameter("name"));
    }





}
